import React from 'react'
import { Widget } from 'features/types'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import CountType from 'enums/CountType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { PreWorkWidgetLoadingGuard, TopicNotSelectedGuard } from '../../share/guards'
import StreamWidgetDataGuards from '../share/guards/StreamWidgetDataGuards'
import FingerprintRunSearchEffect from '../share/searches/FingerprintRunSearchEffect'
import Stream from '../share/Stream'
import SentenceSoundbiteSearchEffect from '../share/searches/SentenceSoundbiteSearchEffect'
import LoadMoreGuard from '../share/guards/LoadMoreGuard'
import WidgetSettingContext from '../share/widgetSettingContext'
import { useStreamWidgetLoadMoreInfo } from '../share/useStreamWidgetLoadMoreInfo'

const AudienceStream: Widget = ({ widgetId }) => {
  const {
    loadMoreCursor,
    maxSoundbites,
    countType,
    handleLoadMore
  } = useStreamWidgetLoadMoreInfo<AudienceStreamWidget>(widgetId)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <FingerprintRunSearchEffect widgetId={widgetId} countType={countType}>
          <PreWorkWidgetLoadingGuard widgetId={widgetId}>
            <StreamWidgetDataGuards widgetId={widgetId}>
              <SentenceSoundbiteSearchEffect widgetId={widgetId} fingerprintIndex={loadMoreCursor}>
                <LoadMoreGuard widgetId={widgetId}>
                  <WidgetSettingContext.Provider
                    value={{ countType: CountType.MENTIONS, maxSoundbites }}>
                    <Stream
                      widgetId={widgetId}
                      fingerprintIndex={loadMoreCursor}
                      callback={handleLoadMore}
                    />
                  </WidgetSettingContext.Provider>
                </LoadMoreGuard>
              </SentenceSoundbiteSearchEffect>
            </StreamWidgetDataGuards>
          </PreWorkWidgetLoadingGuard>
        </FingerprintRunSearchEffect>
      </TopicNotSelectedGuard>
    </UnexpectedErrorBoundary>
  )
}

export default AudienceStream
